module.exports = __webpack_public_path__ + "images/DEV_THUMBNAIL_01-f0b5787d8b3cef0ebb4177490660617f.jpg";